import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { WhatsAppButton } from "@/components/customer/WhatsAppButton";

import Home from "@/pages/Home";
import Checkout from "@/pages/Checkout";
import TrackOrder from "@/pages/TrackOrder";
import Support from "@/pages/Support";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Orders from "@/pages/admin/Orders";
import Comprobantes from "@/pages/admin/Comprobantes";
import Services from "@/pages/admin/Services";
import Customers from "@/pages/admin/Customers";
import Coupons from "@/pages/admin/Coupons";
import Subscriptions from "@/pages/admin/Subscriptions";
import Traffic from "@/pages/admin/Traffic";
import Costs from "@/pages/admin/Costs";
import Providers from "@/pages/admin/Providers";
import ProviderBalances from "@/pages/admin/ProviderBalances";
import Users from "@/pages/admin/Users";
import Tickets from "@/pages/admin/Tickets";
import Reports from "@/pages/admin/Reports";
import Activity from "@/pages/admin/Activity";
import Settings from "@/pages/admin/Settings";

const CustomerHome = () => (
  <>
    <Home />
    <WhatsAppButton />
  </>
);

const CheckoutPage = () => (
  <>
    <Checkout />
    <WhatsAppButton />
  </>
);

function App() {
  return (
    <div className="App">
      <ThemeProvider>
      <AuthProvider>
        <SettingsProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<CustomerHome />} />
              <Route path="/servicios" element={<CustomerHome />} />
              <Route path="/como-funciona" element={<CustomerHome />} />
              <Route path="/preguntas-frecuentes" element={<CustomerHome />} />
              <Route path="/checkout/:slug" element={<CheckoutPage />} />
              <Route path="/consultar-pedido" element={<TrackOrder />} />
              <Route path="/soporte" element={<Support />} />

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="pedidos" element={<Orders />} />
                <Route path="comprobantes" element={<Comprobantes />} />
                <Route path="tickets" element={<Tickets />} />
                <Route path="servicios" element={<Services />} />
                <Route path="clientes" element={<Customers />} />
                <Route path="cupones" element={<Coupons />} />
                <Route path="suscripciones" element={<Subscriptions />} />
                <Route path="recurrencia" element={<Subscriptions />} />
                <Route path="trafico" element={<Traffic />} />
                <Route path="costos" element={<Costs />} />
                <Route path="proveedores" element={<Providers />} />
                <Route path="saldo-proveedores" element={<ProviderBalances />} />
                <Route path="reportes" element={<Reports />} />
                <Route path="actividad" element={<Activity />} />
                <Route path="configuracion" element={<Settings />} />
                <Route path="administradores" element={<Users />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </SettingsProvider>
      </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
